module.exports = __webpack_public_path__ + "assets/img/00059.5e42f4a3.png";